import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { useChannels } from '../../channels';
import { getPrefilledLink, useTextMessage } from '../utils';
import { ChatButton } from './ChatButton';

export const StandaloneButton = () => {
  // @TODO fix type
  const { prefilledMessage } = useSettings();
  const currentPrefilledMessage = prefilledMessage?.replace(
    /(<([^>]+)>)/gi,
    ''
  );
  const [channels] = useChannels();
  const textMessage = useTextMessage({
    message: currentPrefilledMessage,
    withTags: true
  });
  const prefilledLink = getPrefilledLink(channels?.link, textMessage);

  return (
    <ButtonContainer>
      <ChatButton {...channels} link={prefilledLink || ''} />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
